import {
  addGlobalContexts,
  clearGlobalContexts,
  newTracker,
} from '@snowplow/browser-tracker'
import { WebVitalsPlugin } from '@snowplow/browser-plugin-web-vitals'
import { PerformanceTimingPlugin } from '@snowplow/browser-plugin-performance-timing'
import * as webVitals from 'web-vitals'

import config from 'constants/config'
import Snowplow from 'constants/snowplow'
import { APP_CONTEXT_SCHEMA } from 'constants/analytics'

import { baseContext } from './snowplow/events'
import overrideTrackerIds from './snowplow/helpers/overrideTrackedIds'

import { reportClientError } from 'services/errorReportingService'

import { getWhiteLabelAppConfig } from 'lib/whitelabels/whitelabels'
import { getCookies, deleteCookie } from 'lib/web/cookieUtils'

export { trackClientEvent, trackEvent } from './trackClientEvent'

if (typeof window !== 'undefined') {
  (window as any).webVitals = webVitals
}

let listenerAdded = false
export function init() {
  if (!config.TRACKING_HOST) return

  const mobileAppPlatform = getWhiteLabelAppConfig().platform

  const tracker = newTracker(Snowplow.trackerName, config.TRACKING_HOST, {
    appId: mobileAppPlatform ? config.wlMobileApp?.[mobileAppPlatform]?.snowplow?.appId : config.snowplow.appId,
    platform: mobileAppPlatform ? 'app' : 'web',
    // Snowplow v4 defaults to root-domain cookie discovery; keep the existing per-host cookie behavior.
    discoverRootDomain: false,
    // Snowplow v4 defers cookie writes by default. Keep init cookie writes synchronous so
    // overrideTrackerIds can safely read-modify-write the tracker cookies immediately after init.
    synchronousCookieWrite: true,
    plugins: [
      WebVitalsPlugin({
        loadWebVitalsScript: false,
      }),
      PerformanceTimingPlugin(),
    ],
    // you must specify the path since the default path
    // /com.snowplowanalytics.snowplow/tp2 will be blocked by adblock
    postPath: Snowplow.postPath,
    // not-encoding the data makes debugging easier
    encodeBase64: false,
  })

  try {
    // If user came from mobile webview or we want to override the userId data, we grab custom cookies to
    // override Snowplow with those Ids
    const dict = getCookies()
    if (
      tracker &&
      (dict[Snowplow.domainUserIdCookie] || dict[Snowplow.sessionIdCookie] || dict[Snowplow.sessionIdxCookie])
    ) {
      overrideTrackerIds(
        tracker,
        dict[Snowplow.sessionIdCookie],
        dict[Snowplow.domainUserIdCookie],
        Number.isFinite(dict[Snowplow.sessionIdxCookie]) ? Number(dict[Snowplow.sessionIdxCookie]) : undefined,
      )

      deleteCookie(Snowplow.sessionIdxCookie)
      deleteCookie(Snowplow.sessionIdCookie)
    }
  } catch(err) {
    reportClientError(new Error('Snowplow init error'), { error: err.message })
  }

  if (!listenerAdded) {
    listenerAdded = true
    resetContext()
  }
}

export function resetContext() {
  clearGlobalContexts()

  addGlobalContexts([
    {
      schema: APP_CONTEXT_SCHEMA,
      data: {
        appVersion: config.COMMIT_SHA || '-',
      },
    },
    baseContext,
  ])
}
